import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';
import { SERVICE_QUATATIONS_ENDPOINTS } from 'src/app/core/api/endpoints/service-quatations.endpoints';

@Injectable({
  providedIn: 'root',
})
export class ServiceQuatationsService {
  private api = inject(ApiService);

  getServiceQutationOptions(orderId, all = false): Observable<any> {
    let endPoint = SERVICE_QUATATIONS_ENDPOINTS.V1.SERVICE_PROVIDERS(orderId);
    return this.api.get(endPoint, {
      params: all ? { all: true } : {},
    });
  }

  getServiceQuatations(orderId): Observable<any> {
    return this.api.get(
      SERVICE_QUATATIONS_ENDPOINTS.V1.ORDER_QUOTATIONS(orderId),
    );
  }

  sendSelectedServiceQuatationOptions(data): Observable<any> {
    return this.api.post(
      SERVICE_QUATATIONS_ENDPOINTS.V1.CREATE_ORDER_QUOTATIONS,
      data,
    );
  }

  sendOrderQuatation(data): Observable<any> {
    return this.api.post(
      SERVICE_QUATATIONS_ENDPOINTS.V1.SEND_ORDER_QUOTATION,
      data,
    );
  }
}
